import React from 'react';
import { useModals } from '../../../../contexts/ModalsContext';
import { ModalActionsEnum } from '../../../document-table/DocumentTableConstants';
import PdfUploadContainer from './containers/PdfUploadContainer';
import DocxImportContainer from './containers/DocxImportContainer';
import AttachmentUploadContainer from './containers/AttachmentUploadContainer';
import { BaseUploadProps } from './common/types';

interface FileUploadModalProps extends BaseUploadProps {
  templateUpload?: boolean;
  isPremiumUser?: boolean;
}

// Smart router component that selects the right container based on modal type
export const FileUploadModal: React.FC<FileUploadModalProps> = (props) => {
  const { activeModal } = useModals();

  // Attachment upload
  if (activeModal === ModalActionsEnum.UPLOAD_ATTACHMENT_FILES) {
    return <AttachmentUploadContainer {...props} />;
  }

  // DOCX import
  if (activeModal === ModalActionsEnum.UPLOAD_DOC_FILE) {
    return <DocxImportContainer {...props} />;
  }

  // Default: PDF upload
  return <PdfUploadContainer {...props} />;
};

// Export for backward compatibility
export default FileUploadModal;